/* SKU catalog — shared between PortfolioPage grid and ProductDetailPage */

export const PORTFOLIO_SKUS = [
  { id: 'sku-001', name: 'Electrolyte Drink Mix – Berry Burst', image: 'https://images.unsplash.com/photo-1543362905-f2423ef4e0f8?w=400&h=300&fit=crop', revenue: '$1.2M', roas: '8.4x', velocity: '8.4', impressions: '42.3M', successRate: 94, status: 'Wave-Ready', aiInsight: 'Highest-performing SKU — primed for a Summer Hydration Wave on TikTok', lastWaveDate: 'Mar 2026',
    calendar: [
      { month: 'Jan', wave: 'New Year Hydration Push', budget: '$45K', roas: '9.1x', creators: 312, status: 'completed' },
      { month: 'Feb', wave: 'Berry Burst Challenge', budget: '$38K', roas: '7.9x', creators: 245, status: 'completed' },
      { month: 'Mar', wave: 'Summer Hydration Wave', budget: '$62K', roas: '8.4x', creators: 412, status: 'active' },
      { month: 'Jun', wave: 'Summer Kickoff Wave', budget: '$55K', roas: null, creators: null, status: 'planned' },
      { month: 'Sep', wave: 'Back to School Hydration', budget: '$40K', roas: null, creators: null, status: 'planned' },
      { month: 'Nov', wave: 'Black Friday Bundle Wave', budget: '$75K', roas: null, creators: null, status: 'planned' },
    ],
  },
  { id: 'sku-002', name: 'Sleep Recovery Powder', image: 'https://images.unsplash.com/photo-1763757933292-d8290692edde?w=400&h=300&fit=crop', revenue: '$890K', roas: '7.2x', velocity: '7.2', impressions: '28.1M', successRate: 88, status: 'Strong Performer', aiInsight: 'Evening routine content over-indexes — schedule a Q3 Sleep Campaign', lastWaveDate: 'Mar 2026',
    calendar: [
      { month: 'Mar', wave: 'Sleep Better Wave', budget: '$42K', roas: '7.2x', creators: 298, status: 'active' },
      { month: 'Jul', wave: 'Summer Sleep Reset', budget: '$35K', roas: null, creators: null, status: 'planned' },
      { month: 'Oct', wave: 'Fall Wellness Reset', budget: '$45K', roas: null, creators: null, status: 'planned' },
    ],
  },
  { id: 'sku-003', name: 'Morning Energy Gummies', image: 'https://images.unsplash.com/photo-1483918793747-5adbf82956c4?w=400&h=300&fit=crop', revenue: '$650K', roas: '6.5x', velocity: '6.5', impressions: '19.4M', successRate: 82, status: 'Wave-Ready', aiInsight: 'TikTok unboxing content drives 3.4x more engagement — prioritize short-form', lastWaveDate: 'Feb 2026',
    calendar: [
      { month: 'Feb', wave: 'Morning Ritual Wave', budget: '$32K', roas: '6.5x', creators: 186, status: 'completed' },
      { month: 'May', wave: 'Summer Energy Wave', budget: '$40K', roas: null, creators: null, status: 'planned' },
    ],
  },
  { id: 'sku-004', name: 'Tropical Electrolyte Hydration', image: 'https://images.unsplash.com/photo-1762631178325-2c3aea88f166?w=400&h=300&fit=crop', revenue: '$420K', roas: '7.8x', velocity: '7.8', impressions: '15.2M', successRate: 86, status: 'Strong Performer', aiInsight: 'Tropical flavor resonates with 25-34 demo — expand creator cohort', lastWaveDate: 'Mar 2026',
    calendar: [{ month: 'Mar', wave: 'Tropical Getaway Wave', budget: '$28K', roas: '7.8x', creators: 165, status: 'active' }],
  },
  { id: 'sku-005', name: 'Post-Workout Recovery Blend', image: 'https://images.unsplash.com/photo-1763757933154-d55844eae856?w=400&h=300&fit=crop', revenue: '$780K', roas: '9.1x', velocity: '9.1', impressions: '22.8M', successRate: 90, status: 'Wave-Ready', aiInsight: 'Fitness creators show 9.1x ROAS — top candidate for Performance Wave', lastWaveDate: 'Jan 2026',
    calendar: [{ month: 'Jan', wave: 'Gym Recovery Wave', budget: '$48K', roas: '9.1x', creators: 324, status: 'completed' }],
  },
  { id: 'sku-006', name: 'Daily Wellness Drops', image: 'https://images.unsplash.com/photo-1625865019554-220ea80ea813?w=400&h=300&fit=crop', revenue: '—', roas: '—', velocity: '—', impressions: '—', successRate: 78, status: 'New Opportunity', aiInsight: 'Launching May 2026 — schedule a pre-launch Branding Wave', lastWaveDate: '—',
    calendar: [{ month: 'May', wave: 'Wellness Drops Launch Wave', budget: '$55K', roas: null, creators: null, status: 'planned' }],
  },
  { id: 'sku-007', name: 'Immunity Defense Powder', image: 'https://images.unsplash.com/photo-1763747958224-7726941b0b15?w=400&h=300&fit=crop', revenue: '—', roas: '—', velocity: '—', impressions: '—', successRate: 62, status: 'Needs Attention', aiInsight: 'Low wave success rate — consider R&D test with 25 creators before scaling', lastWaveDate: '—',
    calendar: [],
  },
];

// Deep narrative + demo audience data per SKU — used by ProductDetailPage
export const SKU_DETAIL = {
  'sku-001': {
    tagline: 'The #1 selling hydration SKU across DTC and retail — and the most wave-activated product in the portfolio.',
    positioning: 'Sugar-free, electrolyte-dense, zero-jitter hydration for active adults who refuse performance supplements that taste like chemistry.',
    target_audience: ['Active Millennials 25–38', 'Fitness creators (Nano → Macro)', 'New moms returning to the gym', 'Hybrid athletes'],
    top_channels: ['TikTok (44%)', 'Instagram Reels (31%)', 'ShopMy (17%)', 'YouTube Shorts (8%)'],
    competitor_set: ['HydraPeak', 'SaltStack', 'Nimbus', 'Lytefuel'],
    ingredient_highlights: ['1000mg sodium', '380mg potassium', 'Zero added sugar', 'Electrolyte ratio 3:1:1'],
    case_study: {
      headline: 'March 2026 Wave → 8.4x ROAS in 72 hours',
      summary: 'A 412-creator Wave on TikTok pulled 42.3M impressions, 2.1M engagements, and drove $520K in ShopMy revenue on a $62K spend.',
      proof_points: [
        'Patient Zero @sleepcoach_mia achieved 3.2M impressions in first 47 minutes (+214% velocity vs organic baseline)',
        'Sync-burst across 15 micro-community overlaps triggered algorithm amplification at T+24min',
        'Creator earnings: $118K paid out; avg creator earned $286 (90th percentile: $1,142)',
      ],
    },
  },
  'sku-002': {
    tagline: 'The evening-routine hero — the powder that earns a permanent spot on every nightstand.',
    positioning: 'Magnesium-glycinate + L-theanine blend designed for stress recovery sleep (not sedation). Formulated by a sleep physiologist.',
    target_audience: ['Burnout-prone Millennial professionals', 'Sleep-coach creators', 'Biohackers', 'Parents of infants/toddlers'],
    top_channels: ['Instagram Reels (38%)', 'TikTok (30%)', 'YouTube long-form (22%)', 'ShopMy (10%)'],
    competitor_set: ['MagniRest', 'Luna Mag', 'CalmWorks'],
    ingredient_highlights: ['300mg mag glycinate', '200mg L-theanine', 'Zero melatonin', 'Tart cherry for natural ramp'],
    case_study: {
      headline: 'March 2026 Sleep Wave → 298 creators activated',
      summary: 'Evening routine content dominated — 7.2x ROAS, 28M impressions, $304K revenue on $42K spend.',
      proof_points: [
        'Peak posting window 8–11 PM produced +1.8× lift vs daytime slots',
        'ASMR-style content on TikTok hit 94% video completion rate (category avg: 62%)',
        'Sentiment score 92 (Very Positive) — competitor mentions <0.4%',
      ],
    },
  },
  'sku-003': {
    tagline: 'Chewable clean-energy gummies for people who hate the 3pm crash but refuse another Red Bull.',
    positioning: 'Natural caffeine from green tea + B12 + L-tyrosine. Vegan, sugar-free, 4-hour smooth release with no crash.',
    target_audience: ['Gen Z students', 'WFH professionals', 'Busy parents', 'Light-caffeine switchers'],
    top_channels: ['TikTok (52%)', 'Instagram Reels (28%)', 'ShopMy (14%)', 'Amazon (6%)'],
    competitor_set: ['Zest Daily Energy', 'Earthstock B12', 'Voltbrew'],
    ingredient_highlights: ['75mg natural caffeine', '500mcg B12', '300mg L-tyrosine', 'No artificial colors'],
    case_study: {
      headline: 'February 2026 Morning Ritual Wave → 6.5x ROAS',
      summary: '186-creator Wave on TikTok; unboxing content format drove 3.4× higher engagement than traditional product reviews.',
      proof_points: [
        'TikTok unboxing creators achieved 8.9% avg engagement (category avg: 4.2%)',
        'Top creator hit 2.4M views in 48 hours with "morning routine" series',
        'Cart additions peaked 6–9 AM aligned with content posting schedule',
      ],
    },
  },
  'sku-004': {
    tagline: 'The travel-ready hydration everyone reaches for on vacation — and then keeps buying when they\'re home.',
    positioning: 'Single-serve mango-pineapple hydration sticks. Destination-worthy flavor, convenience-store dimensions.',
    target_audience: ['Travel creators', '25–34 lifestyle audience', 'Women\'s wellness', 'Beach / poolside content'],
    top_channels: ['Instagram Reels (45%)', 'TikTok (32%)', 'ShopMy (18%)', 'YouTube (5%)'],
    competitor_set: ['HydraPeak Sugar-Free', 'Nimbus Sport'],
    ingredient_highlights: ['Natural mango-pineapple', '3g coconut water concentrate', 'Zero added sugar', 'Pocket-sized 6g stick'],
    case_study: {
      headline: 'March 2026 Tropical Getaway Wave → 7.8x ROAS',
      summary: '165 lifestyle creators posted from actual vacation settings; authenticity drove 25–34 demo conversion spike.',
      proof_points: [
        'Beach/pool content over-indexed by 4.1× vs studio content',
        'Repeat purchase rate hit 34% within 30 days of first wave exposure',
        'Tropical flavor resonated 2.8× higher in coastal vs interior US regions',
      ],
    },
  },
  'sku-005': {
    tagline: 'Performance-grade recovery blend trusted by gym creators who actually train — not just pose.',
    positioning: 'BCAA + creatine + tart cherry recovery stack. Post-workout window optimization, zero gums or fillers.',
    target_audience: ['Serious fitness creators', 'Hybrid athletes', 'CrossFit community', 'Strength-training women'],
    top_channels: ['Instagram Reels (41%)', 'TikTok (29%)', 'YouTube long-form (20%)', 'ShopMy (10%)'],
    competitor_set: ['Peak Bloom Recovery', 'ClearLab BCAA', 'Alpine Labs Recovery'],
    ingredient_highlights: ['5g BCAA 2:1:1', '3g creatine mono', '480mg tart cherry', 'Clinically-studied doses'],
    case_study: {
      headline: 'January 2026 Gym Recovery Wave → 9.1x ROAS (portfolio record)',
      summary: '324 fitness creators activated in a synchronized 72-hour wave; category-leading ROAS driven by high-intent audience overlap.',
      proof_points: [
        'Fitness-creator DNA match averaged 91% vs target buyer profile',
        'Post-workout content window (5–8 PM) captured 68% of conversions',
        'Top 25 creators achieved 4.2x avg repeat-purchase within 60 days',
      ],
    },
  },
  'sku-006': {
    tagline: 'The clean-label drops that work where you\'d expect a capsule — and a fraction of the volume.',
    positioning: 'Liquid multi-nutrient drops: 14 essentials, 1 ml daily, water-soluble absorption. Planned for May 2026 debut.',
    target_audience: ['Clean-beauty/lifestyle audiences', 'Capsule-fatigue consumers', 'Plant-based community'],
    top_channels: ['TBD — launch scheduled for May 2026'],
    competitor_set: ['HydraPeak Multi', 'Root Cycle Drops', 'Bright Start'],
    ingredient_highlights: ['14 essential micronutrients', 'Vegan, zero fillers', 'Passion fruit natural flavor', '30-day glass bottle'],
    case_study: {
      headline: 'Pre-launch R&D testing — 25 creators live',
      summary: 'Blind testing across 25 creators over 30 days. 89% sentiment score; 84% purchase intent on reveal.',
      proof_points: [
        'Pre-launch waitlist: 12,400 signups from 3 teaser posts',
        'Flavor profile scored 4.6/5 across all tester demos',
        'Clean-label messaging tested 2.1× more persuasive than efficacy messaging',
      ],
    },
  },
  'sku-007': {
    tagline: 'An immunity formula in an overcrowded category — clinical doses, hard to differentiate on shelf.',
    positioning: 'Daily immunity powder: elderberry + zinc + vitamin D3 + quercetin. Doctor-formulated, physician-endorsed.',
    target_audience: ['Parents of school-age kids', 'Seniors 55+', 'Immune-compromised consumers'],
    top_channels: ['Amazon (48%)', 'ShopMy (22%)', 'Instagram Reels (18%)', 'TikTok (12%)'],
    competitor_set: ['FizzDefense', 'Skyshield', 'Earthstock Wellblends'],
    ingredient_highlights: ['500mg elderberry', '15mg zinc', '2000 IU vitamin D3', '250mg quercetin'],
    case_study: {
      headline: 'R&D recommendation: scale back before next wave',
      summary: 'Competitive immunity category requires differentiation before mass creator activation. Recommend 25-creator test to refine messaging.',
      proof_points: [
        'Current creator success rate 62% (portfolio avg: 86%)',
        'Sentiment neutral/mixed — seniors over-index but Gen Z audience rejects',
        'Recommendation: reformulate for clean-label or bundle with SKU-001',
      ],
    },
  },
};

export const UNRELEASED_SKUS = [
  { id: 'ur-1', name: 'Hydration Stick Packs – Citrus', image: 'https://images.unsplash.com/photo-1574537899275-c8a8188887bb?w=400&h=300&fit=crop' },
  { id: 'ur-2', name: 'Collagen Beauty Elixir', image: 'https://images.unsplash.com/photo-1662673146101-b9ce6400578b?w=400&h=300&fit=crop' },
  { id: 'ur-3', name: 'Focus & Flow Nootropic', image: 'https://images.unsplash.com/photo-1765572757676-9794c597c50d?w=400&h=300&fit=crop' },
];

export const STATUS_COLORS = {
  'Wave-Ready':       { bg: '#00F5FF15', text: '#00F5FF', border: '#00F5FF30' },
  'Strong Performer': { bg: '#4ade8015', text: '#4ade80', border: '#4ade8030' },
  'Needs Attention':  { bg: '#FFB02015', text: '#FFB020', border: '#FFB02030' },
  'New Opportunity':  { bg: '#FF6BBD15', text: '#FF6BBD', border: '#FF6BBD30' },
};
